import PropTypes from "prop-types";
import { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";

import { HeaderLink } from "../../partials/HeaderLinks";

import ExportModal from "./ExportModal";

class Export extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  close = () => {
    this.setState({
      isOpen: false
    });
  };

  render() {
    const { t } = this.props;
    return (
      <Fragment>
        <HeaderLink
          onActivation={this.toggle}
          linkIcon={["fal", "download"]}
          linkLabel={t("documentReports.export.exportLink")}
        />
        <ExportModal
          isOpen={this.state.isOpen}
          onClose={this.close}
          csvQuery={this.props.csvQuery}
          queryName={this.props.queryName}
          csvQueryArgs={this.props.csvQueryArgs}
        />
      </Fragment>
    );
  }
}

Export.propTypes = {
  csvQuery: PropTypes.func.isRequired
};

export default withTranslation()(Export);
